import {Injectable} from "@angular/core";
import {FormDto} from "../../core/interfaces/core.types";

@Injectable({ providedIn: 'root' })
export abstract class UserProfileService {

  email: string | undefined;
  phone: string | undefined;

  updateCompleted() {
    this.email = undefined;
    this.phone = undefined;
  }

}
